import { Box } from "@mui/material";
import LocalMallOutlinedIcon from "@mui/icons-material/LocalMallOutlined";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import { theme } from "../../../../utils/theme";

type OrderStatusTimelineProps = {
  status: number;
};

const STYLE_ICON = {
  width: { xs: "40px", sm: "50px" },
  height: { xs: "40px", sm: "50px" },
  display: "block",
};

const STATUS_LABELS = ["Order", "Approved", "Completed"];

export function OrderStatusTimeline({ status }: OrderStatusTimelineProps) {
  return (
    <Box sx={{ px: { xs: 0.5, sm: 2 }, mb: 2 }}>
      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)" }}>
        {STATUS_LABELS.map((label, index) => (
          <Box
            key={label}
            sx={{
              textAlign: "center",
              fontWeight: 600,
              color:
                status >= index + 1
                  ? `${theme.palette.common.green}`
                  : "#898A8D",
            }}>
            {label}
          </Box>
        ))}
      </Box>

      <Box
        sx={{
          position: "relative",
          mt: 1,
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          alignItems: "center",
        }}>
        <Box
          sx={{
            position: "absolute",
            left: "16.666%",
            right: "16.666%",
            top: "50%",
            transform: "translateY(-50%)",
            borderBottom: "2px solid",
            borderColor: status >= 2 ? `${theme.palette.common.green}` : "#898A8D",
            zIndex: 0,
          }}
        />
        <Box sx={{ display: "flex", justifyContent: "center", zIndex: 1 }}>
          <LocalMallOutlinedIcon
            sx={{
              ...STYLE_ICON,
              color: status >= 1 ? `${theme.palette.common.green}` : "#898A8D",
              bgcolor: "#fff",
            }}
          />
        </Box>
        <Box sx={{ display: "flex", justifyContent: "center", zIndex: 1 }}>
          <AssignmentTurnedInOutlinedIcon
            sx={{
              ...STYLE_ICON,
              color: status >= 2 ? `${theme.palette.common.green}` : "#898A8D",
              bgcolor: "#fff",
            }}
          />
        </Box>
        <Box sx={{ display: "flex", justifyContent: "center", zIndex: 1 }}>
          <MonetizationOnOutlinedIcon
            sx={{
              ...STYLE_ICON,
              color: status >= 3 ? `${theme.palette.common.green}` : "#898A8D",
              bgcolor: "#fff",
            }}
          />
        </Box>
      </Box>
    </Box>
  );
}
